import React, { useContext } from 'react';
import styled from 'styled-components';
import { MuiOtpInput } from 'mui-one-time-password-input';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { LocaleContext } from 'routes/Router';
import { useSelector } from 'react-redux';

const WrapperDiv = styled.div`
  margin-top: ${(props) => props?.marginTop + 'px'};
  justify-content: ${(props) => props?.justifyContent};
  display: flex;
  direction: ${(props) => props?.locale == 'ar' && 'ltr'};
  width: 100%;
  @media screen and (max-width: 600px) {
    padding: 0 10px;
  }
`;

const WrapperMuiOtpInput = styled(MuiOtpInput)`
  .MuiFormControl-root {
    .MuiInputBase-root {
      // width: 115px;
      height: 64px;
      border: 1px solid #000000;
      border-radius: 20px;
      .MuiOutlinedInput-notchedOutline {
        border: none;
      }
      .MuiInputBase-input::placeholder {
        color: #999999;
        opacity: 1;
      }
    }

    .MuiInputBase-root.Mui-focused {
      background-color: #e8e8e8;

      .MuiInputBase-input {
        color: #ffffff;
      }
    }
  }

  .MuiFormControl-root:nth-child(-n + ${(props) => props?.value?.length}) {
    .MuiInputBase-root {
      background: #000000;
      color: #ffffff;
    }
  }
`;

const WrapperErrorDiv = styled.div`
  font-size: 18px;
  color: ${(props) => props?.theme?.errorColor};
  line-height: 27px;
  font-weight: 600;
  font-family: Inter_SemiBold;
  margin-top: 5px;
`;

const OtpInput = ({ marginTop, justifyContent, ...props }) => {
  const { locale } = useContext(LocaleContext);

  return (
    <>
      <WrapperDiv
        marginTop={marginTop}
        justifyContent={justifyContent}
        locale={locale}
      >
        <WrapperMuiOtpInput autoFocus {...props} />
      </WrapperDiv>
      {props.errorText && (
        <WrapperErrorDiv locale={locale}>
          <ErrorOutlineIcon /> {props.errorText}
        </WrapperErrorDiv>
      )}
    </>
  );
};

OtpInput.defaultProps = {
  justifyContent: 'center',
};

export default OtpInput;
